import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = ({ store, onSave, onShare, onDirections, isSaved }) => {
  return (
    <div className="relative w-full bg-card">
      <div className="relative w-full h-64 md:h-80 lg:h-96 overflow-hidden">
        <Image
          src={store?.heroImage}
          alt={store?.heroImageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/40 to-transparent" />
      </div>
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="relative -mt-16 md:-mt-20 lg:-mt-24 pb-6 md:pb-8 lg:pb-10">
          <div className="flex flex-col lg:flex-row gap-4 md:gap-6 lg:gap-8">
            <div className="w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40 rounded-lg md:rounded-xl lg:rounded-2xl overflow-hidden bg-card shadow-warm-lg flex-shrink-0 border-4 border-card">
              <Image
                src={store?.logo}
                alt={store?.logoAlt}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
                    {store?.name}
                  </h1>
                  
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-3 md:mb-4">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-caption font-semibold">
                      <Icon name={store?.categoryIcon} size={16} />
                      {store?.category}
                    </span>
                    
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary/10 text-secondary text-sm font-caption">
                      <Icon name="MapPin" size={16} />
                      {store?.zone}
                    </span>

                    {store?.badges?.map((badge, index) => (
                      <span
                        key={index}
                        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-caption ${
                          badge?.type === 'verified'
                            ? 'bg-success/10 text-success'
                            : badge?.type === 'premium' ?'bg-accent/10 text-accent' :'bg-muted text-muted-foreground'
                        }`}
                      >
                        <Icon name={badge?.icon} size={16} />
                        {badge?.label}
                      </span>
                    ))}
                  </div>

                  <div className="flex items-center gap-2 mb-4">
                    <div className="flex items-center gap-1">
                      {[1, 2, 3, 4, 5]?.map((star) => (
                        <Icon
                          key={star}
                          name={star <= Math.floor(store?.rating) ? 'Star' : 'Star'}
                          size={20}
                          className={
                            star <= Math.floor(store?.rating)
                              ? 'text-primary fill-primary' :'text-muted-foreground'
                          }
                        />
                      ))}
                    </div>
                    <span className="text-base md:text-lg font-heading font-semibold text-foreground">
                      {store?.rating?.toFixed(1)}
                    </span>
                    <span className="text-sm text-muted-foreground">
                      ({store?.reviewCount} recensioni)
                    </span>
                  </div>
                </div>

                <div className="flex flex-row md:flex-col gap-2 md:gap-3">
                  <Button
                    variant={isSaved ? 'default' : 'outline'}
                    size="default"
                    iconName={isSaved ? 'Heart' : 'Heart'}
                    iconPosition="left"
                    onClick={onSave}
                    className="flex-1 md:flex-none md:w-full"
                  >
                    {isSaved ? 'Salvato' : 'Salva'}
                  </Button>

                  <Button
                    variant="outline"
                    size="default"
                    iconName="Share2"
                    iconPosition="left"
                    onClick={onShare}
                    className="flex-1 md:flex-none md:w-full"
                  >
                    Condividi
                  </Button>

                  <Button
                    variant="default"
                    size="default"
                    iconName="Navigation"
                    iconPosition="left"
                    onClick={onDirections}
                    className="flex-1 md:flex-none md:w-full"
                  >
                    Indicazioni
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;